// extracted by mini-css-extract-plugin
export default {"landingPage":"LandingPage_landingPage__21Rke","landing":"LandingPage_landing__qtCcT","image":"LandingPage_image__hAhE5","sousTitle":"LandingPage_sousTitle__pNW1D"};